import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionPhotoLogCreatePayload,
	IActionPhotoLogCreatePayloadDone,
	IActionPhotoLogCreatePayloadError,
} from './types';

export const photoLogCreate = actionCreatorAsync<
	IActionPhotoLogCreatePayload,
	IActionPhotoLogCreatePayloadDone,
	IActionPhotoLogCreatePayloadError
>(
	'photoLogCreate',
	async (params) => {
		const { photoLog } = params;
		const { data } = await Api.photoLog.create({
			body: photoLog,
		});

		return data;
	},
);
